import { useLoaderData } from "react-router";
import { getBlogs } from "app/.server/blogs";
import { getMeta } from "app/utils/meta";
import { getLoaderTrans } from "app/.server/utils";
import BlogListItem from "app/components/blogs/blog-list-item";
import PinnedArticles from "app/components/blogs/pinned-articles";
import Link from "app/components/i18n/Link";
import Layout from "app/components/layout";
import Sprite from "app/components/sprite";
import { Trans } from "react-i18next";

export const loader = async ({ request, params }) => {
  const trans = await getLoaderTrans({ request, params });
  const blogs = await getBlogs();

  return {
    posts: blogs,
    meta: {
      title: `${trans("Blog")} | Where you will find the latest about cCommerce, the benefits of connected commerce, tips about running your online business, and updates on Zbooni.`,
    },
  };
};

export const meta = ({ loaderData: data }) => {
  return getMeta({
    title: data.meta.title,
  });
};

const BlogsList = () => {
  const { posts } = useLoaderData();

  const pinnedPosts = posts.filter((post) => post.frontmatter.pinned);

  return (
    <Layout headerIsOnTop={false} enableHeaderShrinkingOnScroll={false}>
      <div className="relative h-full overflow-hidden bg-lightgray font-montserrat">
        <header className="bg-primary ">
          <div className="zbooni-layout pt-24 h-72 relative overflow-hidden">
            <Sprite
              name="donut"
              fill="#FFF"
              className="absolute opacity-[.08] w-[230px] md:w-[442px] h-[230px] md:h-[442px] top-28 md:top-20 ltr:-right-6 ltr:md:right-0 rtl:-left-6 rtl:md:left-0"
            />
            <h1 className="text-2xl font-extrabold text-white xs:text-[28px] sm:text-[32px]">
              <Trans>Blogs</Trans>
            </h1>
          </div>
        </header>
        <div className="bg-lightgray">
          <div className="zbooni-layout">
            <div className="relative -top-32 md:-top-24 flex flex-col gap-y-7">
              <PinnedArticles posts={pinnedPosts} />
              {posts.map((post, index) => {
                if (post.frontmatter.pinned) return;

                return (
                  <div key={index} className="rounded-2xl bg-white">
                    {post.frontmatter.hasDetailPage ? (
                      <Link
                        to={`/blog/${post.slug}`}
                        className="flex flex-col px-5 py-10 delay-75 hover:opacity-50 hover:transition lg:flex-row lg:flex-wrap lg:px-10 xl:inline-grid xl:grid-flow-col xl:grid-cols-12"
                      >
                        <BlogListItem post={post.frontmatter} />
                      </Link>
                    ) : (
                      <div className="flex flex-col px-5 py-10 lg:flex-row lg:flex-wrap lg:px-10 xl:inline-grid xl:grid-flow-col xl:grid-cols-12">
                        <BlogListItem post={post.frontmatter} />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default BlogsList;
